
      <div class="col-lg-6 col-xs-12">

          <div class="panel panel-default">
              <div class="panel-body">

   <div style="display: block">
      <canvas baseChart
              [datasets]="radarChartData"
              [labels]="radarChartLabels"
              [chartType]="radarChartType"
              (chartHover)="chartHovered($event)"
              (chartClick)="chartClicked($event)"></canvas>
    </div>

 </div>
</div>
</div>



// WEBPACK FOOTER //
// ./src/app/report/charts/radar-chart/radar-chart.component.html